import {
  CampaignsState,
  REQUEST_CAMPAIGNS,
  REQUEST_CAMPAIGNS_DONE
} from "./types";

const initialState: CampaignsState = {
  isLoading: true,
  campaigns: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_CAMPAIGNS:
      return {
        isLoading: true,
        campaigns: action.payload
      };
    case REQUEST_CAMPAIGNS_DONE:
      return {
        isLoading: false,
        campaigns: action.payload
      };
    default:
      return state;
  }
}
